import React, { Component } from "react";
import { Table } from "reactstrap";
import Moment from "moment";
import ProyectoCostoModal from "./ProyectoCostoModal";
import ConfirmPartidaRemovalModal from "./ConfirmPartidaRemovalModal";

class ProyectoDetailPartidasList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchQuery: "",
    };
  }

  // Util para evitar fallos con undefined y formatear números
  fmtNumber = (n) => {
    const num = Number(n ?? 0);
    return Number.isFinite(num) ? num.toLocaleString() : "";
  };

  render() {
    const { partidas } = this.props;

    return (
      <div>
        <Table responsive hover striped bordered>
          <thead>
            <tr className="table-danger">
              <th>Partida</th>
              <th>Producto</th>
              <th>Proveedor</th>
              <th>Asignado</th>
              <th>Instructor</th>
              <th>Precio Unitario</th>
              <th>Costo Unitario</th>
              <th>Cantidad</th>
              <th>Precio Total</th>
              <th>Costo Total</th>
              {/* Moneda removed - inherited from project */}
              <th>Referencia</th>
              <th>Fecha de Registro</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!partidas || partidas.length <= 0 ? (
              <tr>
                <td colSpan="15" align="center">
                  <b>Ups, todavía no hay partidas!!</b>
                </td>
              </tr>
            ) : (
              partidas.map((partida) => (
                <tr key={partida.pk}>
                  <td>{partida.partida}</td>
                  <td>{partida.producto}</td>
                  <td>{partida.proveedor}</td>

                  {/* NUEVAS COLUMNAS */}
                  <td>{partida.asignado}</td>
                  <td>
                    {/* Si está asignado a Instructor mostramos miembro_asignado */}
                    {partida.asignado === "Instructor" ? (partida.miembro_asignado || "") : ""}
                  </td>

                  <td>{this.fmtNumber(partida.precio)}</td>
                  <td>{this.fmtNumber(partida.costo)}</td>
                  <td>{this.fmtNumber(partida.cantidad)}</td>
                  <td>{this.fmtNumber(partida.totalPrice)}</td>
                  <td>{this.fmtNumber(partida.totalCost)}</td>
                  {/* Moneda removed - inherited from project */}
                  <td>{partida.referencia}</td>
                  <td>{partida.registration_date ? Moment(partida.registration_date).format("MMM/DD/yy") : ""}</td>
                  <td align="center">
                    <ProyectoCostoModal
                      create={false}
                      partida={partida}
                      resetState={this.props.resetState}
                      instructores={this.props.instructores}
                      proyectoMoneda={this.props.selectedProyecto?.moneda || 'USD'}
                      ingresoProyecto={this.props.ingresoProyecto}
                    />
                    &nbsp;&nbsp;
                    <ConfirmPartidaRemovalModal pk={partida.pk} resetState={this.props.resetState} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default ProyectoDetailPartidasList;